var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack426({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.23,12.78V4.91H7.78A9.06,9.06,0,0,1,9.67,5a2.09,2.09,0,0,1,1.14.77,2.44,2.44,0,0,1,.45,1.53A2.53,2.53,0,0,1,11,8.55a2.14,2.14,0,0,1-.67.78,2.4,2.4,0,0,1-.82.37,9.65,9.65,0,0,1-1.65.11h-1v3ZM6.82,6.24V8.48h.87A4.13,4.13,0,0,0,9,8.35a1,1,0,0,0,.67-1,1,1,0,0,0-.25-.71,1.16,1.16,0,0,0-.64-.35,8.74,8.74,0,0,0-1.14,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack426);
export default __webpack_public_path__ + "static/media/Symbolpack_4_26.6f2dda439055f5d1d7e946d139dd96e8.svg";
export { ForwardRef as ReactComponent };